<script>
import _ from 'lodash'

export default {
    data() {
        return {
            mixinTypeSort: 'desc'
        }
    },
    methods: {
        orderByCustom(data) {
            let currentSortOrder = this.mixinTypeSort === this.currentSortOrder ? this.mixinTypeSort : this.currentSortOrder
            return _.orderBy(data, [this.currentSort], [currentSortOrder])
        }
    }
}
</script>
